var swiper = new Swiper('.carousel', {
    slidesPerView: 3,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    initialSlide : 1
});

jQuery(document).ready(function($){

  jQuery('.accordion').on('click', 'dt', function() {
    var currentItem       = jQuery(this),
        currentAccordion  = currentItem.closest('.accordion');

    if (!currentItem.hasClass('state-active')) {
      currentAccordion.find('.state-active').removeClass('state-active');
      currentItem.addClass('state-active');

      currentAccordion.find('dd').slideUp();
      currentItem.next('dd').slideDown();
    }
    else{
      currentItem.removeClass('state-active');
      currentItem.next('dd').slideUp();
    }
  })

  jQuery('.banner__arrow').on('click', function() {
    $("html, body").animate({ scrollTop: $(window).height() }, 1000);
  })

  jQuery('.banner__add-btn').on('click', function() {
    $("html, body").animate({ scrollTop: $("#shopify-section-product-template").offset().top }, 1000);
  })


  var bannerImg = $(".banner__img img"),
      banner    = $(".banner");

  jQuery(window).on('scroll', function() {
    var currentScrollTop  = $(window).scrollTop(),
        newScrollTop      = currentScrollTop / 8,
        bgScrollIndex     = $(window).width() < 993 ? 6 : 2,
        headerH           = $('#shopify-section-announcement').height() + $('#shopify-section-header').height();

    if (currentScrollTop < 1000){
      bannerImg.css('-webkit-transform','translateY(-'+newScrollTop+'px)');
      bannerImg.css('transform','translateY(-'+newScrollTop+'px)');

      banner.css({
        'backgroundPosition' : '50% calc(100% - '+(currentScrollTop / bgScrollIndex)+'px)'
      });
    }

    if ((currentScrollTop + $(banner).height() + headerH) > (banner.offset().top + banner.height())){
      banner.addClass('hide-tools');
    }
    else{
      banner.removeClass('hide-tools');
    }

  })

  if (jQuery('.banner__add-btn .money').length) {
    jQuery('.banner__add-btn > b').text(''+$('.banner__add-btn .money').text()+'-');
  }

  if (jQuery('.Product__SlideshowNavImage').length){

    jQuery('.Product__SlideshowNavImage, .Heading.Link.Link--secondary').bind('click', function(){ return false; });;

    jQuery('.Product__SlideshowNavImage, .Heading.Link.Link--secondary').on('click', function(e) {
      var currentItem = jQuery(this),
          targetElem  = currentItem.attr('href');

      if (jQuery(targetElem).length) {
        jQuery('html, body').stop().animate({
          scrollTop: jQuery(targetElem).offset().top
        }, 500);
      }

      e.preventDefault();
    })
  }

})